import { ShiftDetailWorker } from '../api/types';

import { formatMarkedAt } from './dateFormat';

type LastMessage = NonNullable<ShiftDetailWorker['last_message']>;

// How it went out, in the words ops use. An unknown channel (a new one the
// server adds) is left out rather than printed raw.
const CHANNEL_LABELS: Record<string, string> = {
  sms: 'text',
  push: 'push',
  push_sms: 'text and push',
  email: 'email',
};

/**
 * GRAVY-10898 CC-1.5: the hired row's "last message" line, e.g.
 * "Confirmation follow-up sent Oct 20, 6:02 AM by text".
 *
 * `held` is a message waiting for quiet hours to end. It has not reached the
 * worker, so it must not read "sent": ops would assume the worker was told.
 * Times are in the shift's timezone, like every other time on the panel.
 */
export const lastMessageText = (
  message?: LastMessage | null,
  tz?: string | null,
): string | null => {
  if (!message) return null;
  const label = message.label || message.kind;

  if (message.status === 'held') {
    return message.scheduled_for
      ? `${label} waiting for quiet hours, goes out ${clean(formatMarkedAt(message.scheduled_for, tz))}`
      : `${label} waiting for quiet hours`;
  }

  const when = message.sent_at
    ? ` ${clean(formatMarkedAt(message.sent_at, tz))}`
    : '';
  const channel = message.channel ? CHANNEL_LABELS[message.channel] : null;
  return `${label} sent${when}${channel ? ` by ${channel}` : ''}`;
};

// ICU puts a narrow no-break space before AM/PM; a plain space keeps the text
// matchable in tests and screen readers.
const clean = (s: string) => s.replace(/[  ]/g, ' ');
